import { render, staticRenderFns } from "./AddSupplierModal.vue?vue&type=template&id=405b173e&scoped=true&"
import script from "./AddSupplierModal.vue?vue&type=script&lang=js&"
export * from "./AddSupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddSupplierModal.vue?vue&type=style&index=1&id=405b173e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b173e",
  null
  
)

export default component.exports